module.exports = __webpack_public_path__ + "img/nasil_eposta.745b1a7d.svg";